import React from "react";
import { v4 as uuidv4 } from 'uuid';
import { Badge, Button, Plus, Select } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import WorkflowNodeFilterGroupForm from "./WorkflowNodeFilterGroupForm";
import LowInventoryNodeForm from "./LowInventoryNodeForm";

const headingStyle = {
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  color: "var(--sl-text-secondary)",
};

const descriptionStyle = {
  fontSize: 14,
  lineHeight: "20px",
  color: "var(--sl-text-tertiary)",
};

export default () => {
  const {
    selectedNode,
    selectedNodeFormState,
    setSelectedNodeFormState,
    customCampaign,
  } = useCustomCampaignShowContext();

  const persistedEventType = selectedNode?.node_data?.event_type;
  const filterType = customCampaign?.trigger_filter_type;
  const eventTypeOptions = (selectedNodeFormState.node_data_options?.event_type || []).map((option) => ({
    value: option,
    label: option,
  }));

  const handleAddEventDataFilter = () => {
    const newFilter = {
      type: filterType,
      tempId: uuidv4(),
    };

    if (Object.keys(selectedNodeFormState.filter_group || {}).length > 0) {
      setSelectedNodeFormState(prevState => ({
        ...prevState,
        filter_group: {
          ...prevState.filter_group,
          filters_attributes: [
            ...prevState.filter_group.filters_attributes,
            newFilter,
          ],
        }
      }));
    } else {
      setSelectedNodeFormState(prevState => ({
        ...prevState,
        filter_group: {
          ...prevState.filter_group,
          match_condition: "All",
          filters_attributes: [
            newFilter,
          ],
        }
      }));
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={headingStyle}>Event</div>
        <div style={descriptionStyle}>This automation kicks off when the following event happens:</div>
      </div>
      {persistedEventType ? (
        <div>
          <Badge type="badge-modern" color="gray">{persistedEventType}</Badge>
        </div>
      ) : (
        <Select
          id="event_type"
          aria-label="Event"
          placeholder="Pick an event"
          options={eventTypeOptions}
          value={selectedNodeFormState.node_data?.event_type || null}
          onChange={(eventType) => {
            setSelectedNodeFormState(prevState => ({
              ...prevState,
              node_data: {
                ...prevState.node_data,
                event_type: eventType,
              },
            }));
          }}
        />
      )}
      {(persistedEventType || selectedNodeFormState.node_data?.event_type) === "Low Inventory" ? (
        <LowInventoryNodeForm />
      ) : null}
      {Object.keys(selectedNodeFormState.filter_group || {}).length > 0 ? (
        <WorkflowNodeFilterGroupForm />
      ) : null}
      {persistedEventType ? (
        <div>
          <Button variant="link-color" size="sm" icon={Plus} onClick={handleAddEventDataFilter}>
            Add event data filter
          </Button>
        </div>
      ) : null}
    </>
  );
};
